<form (ngSubmit)="onSave()" #fUsers="ngForm">
	<div class="main-wrapper">
		<div class="select-info">
			<label>Level:&nbsp;&nbsp; {{ data.Description }}</label>
			<label class="text-right">{{ selectedDesc }}</label>
		</div>
		<div class="table-wrapper">
			<mat-table class="table" [dataSource]="dataSource">
				<ng-container matColumnDef="UserName">
					<mat-header-cell *matHeaderCellDef>
						<span class="column-text">User Name</span>
					</mat-header-cell>
					<mat-cell *matCellDef="let user">
						{{ user.UserName }}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="FullName">
					<mat-header-cell *matHeaderCellDef>
						<span class="column-text">Full Name</span>
					</mat-header-cell>
					<mat-cell *matCellDef="let user">
						{{ user.FullName }}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="Selected">
					<mat-header-cell *matHeaderCellDef>
						<mat-checkbox class="bs-checkbox" aria-label="Select all users" title="Select All" [name]="selectAll"
							[(ngModel)]="allUsersSelected" [ngModelOptions]="{ standalone: true }"
							(click)="dataSource?.data?.length > 0 ? checkAllUsers() : null" [disabled]="dataSource?.data?.length === 0">
						</mat-checkbox>
					</mat-header-cell>
					<mat-cell *matCellDef="let user">
						<mat-checkbox class="bs-checkbox" [name]="'selected-' + user.UserId" [(ngModel)]="user.Selected"
							(change)="checkIfAllUsersSelected()">
						</mat-checkbox>
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
				<mat-row *matRowDef="let row; columns: columnsToDisplay"></mat-row>
			</mat-table>
			<shared-no-data-available *ngIf="dataSource.data.length === 0 && isDataLoaded"></shared-no-data-available>
		</div>

		<div class="save-cancel-wrapper">
			<div>
				<button class="btn btn-cancelSave" type="button" (click)="onCancel()">
					CANCEL
				</button>
			</div>
			<div>
				<button class="btn btn-save pull-right" type="submit" [disabled]="!fUsers.dirty || isReadOnly">
					SAVE
				</button>
			</div>
		</div>
	</div>
</form>
